<template>
    <CRow>
        <CCol col="12" lg="12">
            <CCard>
                <CCardBody>
                    <form
                        @submit.prevent="createRecord('USER', { name:name, email:email, phone:phone, role_id:rol_id, sizes: [{ id: vehicleTypeSizeId }], state_id: state_id }, true)"
                        method="post"
                    >
                        <h3>
                            {{ $t('users.profile') }}
                        </h3>
                        <br>
                        <CRow>
                            <CCol col="6" lg="6">
                                <CInput 
                                    :placeholder="$t('fields.name.placeholder')" 
                                    :label="$t('fields.name.label')" 
                                    v-model="name" 
                                    type="text" 
                                    required
                                ></CInput>
                            </CCol>
                            <CCol col="6" lg="6">
                                <CInput 
                                    :placeholder="$t('fields.whatsapp.placeholder')" 
                                    :label="$t('fields.whatsapp.label')" 
                                    v-model="phone" 
                                    type="text" 
                                    required
                                ></CInput>
                            </CCol>
                            <CCol col="6" lg="6">
                                <CInput 
                                    :placeholder="$t('fields.email.placeholder')" 
                                    :label="$t('fields.email.label')" 
                                    v-model="email" 
                                    type="text" 
                                    required
                                ></CInput>
                            </CCol>
                            <CCol col="6" lg="6">
                                <CRow>
                                    <CCol col="10" lg="10">
                                        <CInput 
                                            :placeholder="$t('typeVehicles.placeholder')" 
                                            :label="$t('typeVehicles.title')" 
                                            v-model="typeVehicleSize" 
                                            type="text" 
                                            required
                                            readonly
                                        ></CInput>
                                    </CCol>
                                    <CCol col="2" lg="2" style="margin-top:20px">
                                        <CButton color="warning" class="m-2" @click="showDetail = true">
                                            <CIcon :content="updateIcon" /> {{ $t('button.options') }}
                                        </CButton>
                                    </CCol>
                                </CRow>
                            </CCol>
                            <CCol col="6" lg="6">
                                <CSelect 
                                    placeholder="Estado donde se ubica" 
                                    label="Estado donde se ubica" 
                                    :options="states"
                                    :value.sync="state_id"
                                    :plain="true"
                                ></CSelect>
                            </CCol>
                       </CRow>
                        <CRow>
                            <CCol col="12" lg="12" class="text-right">
                                <CButton color="success" type="submit" class="m-2">
                                    <template>
                                        <CIcon :content="updateIcon" /> {{ $t('button.update') }}
                                    </template>
                                </CButton>
                            </CCol>
                        </CRow>
                    </form>
                </CCardBody>
            </CCard>
        </CCol>
        <CModal
            color="warning"
            :show.sync="showDetail"
            :title="$t('typeVehicles.title')"
        >
            <div>
                <CRow v-for="typeVehicle in typeVehicles" :key="typeVehicle.id" >
                    <div class="col-sm-12">
                        <label class="label-detail" style="font-weight: bold">
                            {{typeVehicle.name}}
                        </label>
                        <hr/>
                    </div>
                    <div class="col-sm-12" v-for="size in typeVehicle.sizes" 
                        :key="size.id" style="text-align: center; cursor: pointer;"
                        @click="onSelectTipeVehicleSize(typeVehicle, size)">
                        <label class="label-detail">
                            {{size.name}}
                        </label>
                    </div>
                </CRow>
            </div>
        </CModal>
    </CRow>
</template>

<script>
import axios from 'axios'
import catalog from '../../hooks/catalogs';
import { cilSync, cilPlus, cilArrowLeft } from '@coreui/icons';

export default {
    name: 'Profile',
    mixins: [catalog],
    data() {
        return {
            updateIcon: cilSync,
            addIcon: cilPlus,
            backIcon: cilArrowLeft,
            name: null,
            states: [],
            phone: null,
            email: null,
            rol_id: null,
            state_id: null,
            password: null,
            typeVehicles: [],
            showState: false,
            showDetail: false,
            showTypeVehicle: false,
            vehicleTypeSizeId: null,
            roles: [
                {
                    value: 2,
                    label: "Soy Transportista",
                },
                {
                    value: 4,
                    label: "Soy Proveedor",
                },
                {
                    value: 5,
                    label: "Soy Logistico",
                }
            ],
        }
    },
    methods: {
        onSelectTipeVehicleSize(vehicleTypeSize, size) {
            this.showDetail = false;
            this.vehicleTypeSizeId = size.id;
            this.typeVehicleSize = vehicleTypeSize.name + " - " + size.name;
        },
        onSelectRole() {
            this.state_id = null;
            this.typeVehicleSize = "";
            this.vehicleTypeSizeId = null;
            this.showState = (this.rol_id == 2);
            this.showTypeVehicle = (this.rol_id == 2 || this.rol_id == 5);
        },
    },
    async mounted() {
        let self = this;
        const token = localStorage.getItem('token', null);

        axios.get(`type-vehicle`)
            .then(response => {
                response.data.forEach(function(record){
                    self.typeVehicles.push(record);
                });
            }).catch(error => {
                if (error.response.status === 401) {
                    self.$router.push({ path: '/login' });
                } else {
                    self.$toast.error(error.response.data.message);
                }
            });

        axios.get(`states`)
            .then(response => {
                response.data.forEach(function(record){
                    self.states.push({
                        value: record.id,
                        label: record.name,
                    });
                });
            }).catch(error => {
                if (error.response.status === 401) {
                    self.$router.push({ path: '/login' });
                } else {
                    self.$toast.error(error.response.data.message);
                }
            });

        axios.get(`user`, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                }
            })
            .then(response => {
                console.log(response);
                self.name = response.data.name;
                self.phone = response.data.phone;
                self.email = response.data.email;
                self.rol_id = response.data.roles[0].id;
                self.onSelectRole();

                if (self.rol_id == 2) {
                    self.state_id = response.data.state_id;
                    if (response.data.sizes) {
                        self.vehicleTypeSizeId = response.data.sizes[0].id;
                        self.typeVehicleSize = response.data.type_vehicles_string;
                    }
                } else if (self.rol_id == 5) {
                    self.typeVehicles.find(element => element.value == response.data.typeVehicles[0].id)
                }
            }).catch(error => {
                if (error.response.status === 401) {
                    self.$router.push({ path: '/login' });
                } else {
                    self.$toast.error(error.response.data.message);
                }
            });
    }
}
</script>
